module.exports = __webpack_public_path__ + "media/images/webpage/shared/instagram/iphone-mock-0d8e1921eb227c85c3ba45a0d5502d5a.webp";